export const getParentId = (id: string) => {
  const split = id.split("#")
  split.pop()
  return split.join("")
}
